import "bootstrap/dist/css/bootstrap.min.css"
import "./src/styles/main.css"

const HEADER_SCROLL_ON = 100;
const HEADER_SCROLL_OFF = 40;
let headerScrollFrame = 0;

const syncHeaderScrollClass = () => {
    const header = document.getElementById("headerMenu");
    if (!header) return;
    const isActive = header.classList.contains("isScrolledHeader");
    const shouldAnimate = isActive ? window.scrollY > HEADER_SCROLL_OFF : window.scrollY > HEADER_SCROLL_ON;
    if (shouldAnimate === isActive) return;
    header.classList.toggle("isScrolledHeader", shouldAnimate);
};

const requestHeaderScrollSync = () => {
    if (headerScrollFrame) return;
    headerScrollFrame = window.requestAnimationFrame(() => {
        headerScrollFrame = 0;
        syncHeaderScrollClass();
    });
};

export const onInitialClientRender = () => {
    syncHeaderScrollClass();
    window.addEventListener("scroll", requestHeaderScrollSync, { passive: true });
};

export const onRouteUpdate = () => {
    syncHeaderScrollClass();
};